function utf8Encode(str) {
    var x;
    var y;
    var output = '';
    var i = -1;
    var l;
    if (str === null || str === void 0 ? void 0 : str.length) {
        l = str.length;
        while ((i += 1) < l) {
            /* Decode utf-16 surrogate pairs */
            x = str.charCodeAt(i);
            y = i + 1 < l ? str.charCodeAt(i + 1) : 0;
            if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
                x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
                i += 1;
            }
            /* Encode output as utf-8 */
            if (x <= 0x7F) {
                output += String.fromCharCode(x);
            }
            else if (x <= 0x7FF) {
                output += String.fromCharCode(0xC0 | ((x >>> 6) & 0x1F), 0x80 | (x & 0x3F));
            }
            else if (x <= 0xFFFF) {
                output += String.fromCharCode(0xE0 | ((x >>> 12) & 0x0F), 0x80 | ((x >>> 6) & 0x3F), 0x80 | (x & 0x3F));
            }
            else if (x <= 0x1FFFFF) {
                output += String.fromCharCode(0xF0 | ((x >>> 18) & 0x07), 0x80 | ((x >>> 12) & 0x3F), 0x80 | ((x >>> 6) & 0x3F), 0x80 | (x & 0x3F));
            }
        }
    }
    return output;
}
function binl2rstr(input) {
    var i;
    var l = input.length * 32;
    var output = '';
    for (i = 0; i < l; i += 8) {
        output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF);
    }
    return output;
}
function bitRol(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt));
}
function rstr2binl(input) {
    var i;
    var l = input.length * 8;
    var output = Array(input.length >> 2);
    var lo = output.length;
    for (i = 0; i < lo; i += 1) {
        output[i] = 0;
    }
    for (i = 0; i < l; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32);
    }
    return output;
}
function safeAdd(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF);
}
function hex(s) {
    var input = binl2rstr(binl(rstr2binl(s), s.length * 8));
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i = 0;
    var l = input.length;
    for (; i < l; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
    }
    return output;
}
/**
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binl(x, len) {
    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    /* append padding */
    // eslint-disable-next-line
    x[len >> 5] |= 0x80 << len % 32;
    // eslint-disable-next-line
    x[(((len + 64) >>> 9) << 4) + 14] = len;
    for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5Ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = md5Ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5Ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5Ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5Ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5Ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5Ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5Ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5Ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5Ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5Ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5Ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5Ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5Ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5Ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5Ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5Gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5Gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5Gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5Gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = md5Gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5Gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5Gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5Gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5Gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5Gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5Gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5Gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5Gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5Gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5Gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5Gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5Hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5Hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5Hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5Hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5Hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5Hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5Hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5Hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5Hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5Hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = md5Hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5Hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5Hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5Hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5Hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5Hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5Ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = md5Ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5Ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5Ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5Ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5Ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5Ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5Ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5Ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5Ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5Ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5Ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5Ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5Ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5Ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5Ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [a, b, c, d];
}
/**
 * These functions implement the four basic operations the algorithm uses.
 */
function md5Cmn(q, a, b, x, s, t) {
    return safeAdd(bitRol(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5Ff(a, b, c, d, x, s, t) {
    return md5Cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5Gg(a, b, c, d, x, s, t) {
    return md5Cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5Hh(a, b, c, d, x, s, t) {
    return md5Cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5Ii(a, b, c, d, x, s, t) {
    return md5Cmn(c ^ (b | ~d), a, b, x, s, t);
}
/**
 *
 * @param str 想要进行 md5 加密的字符串
 * @returns md5 字符串
 */
export function md5(str) {
    var s = str;
    try {
        s = hex(utf8Encode(str));
    }
    catch (err) {
        console.log(err, 'md5 err');
    }
    return s;
}
